const locale = {
  ACCOUNT_MENU_BUTTON_ARIA_LABEL: 'Account menu, {{name}}',
  GUEST_NAME: 'Guest',
  PROFILE: 'Profile',
  CHANGE_PASSWORD: 'Change your password',
  TWO_AUTHENTICATION: 'Security Settings (2FA)',
  LOGOUT: 'Logout',
  HOME: 'Recommendations',
  SKILLS: 'Skills',
  OCCUPATIONS: 'Career Goals',
  LEARNING_PATHS: 'Learning Paths',
  COURSES: 'Saved courses',
  HELP: 'Help',
  PERSONAL: 'Personal Information',
  PREFERENCES: 'Preferences',
};

export default locale;
